import React, { useState } from "react";
import emailjs from "emailjs-com"; // ✅ EmailJS SDK
import "./ContactUs.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");

    // Replace with your actual EmailJS service ID, template ID, and user ID
    const SERVICE_ID = "service_5ibu8lu";
    const TEMPLATE_ID = "template_z74nx1t";
    const PUBLIC_KEY = "zT_UnjiQ5KIyfdYBP"; // (formerly user_id)

    try {
      await emailjs.send(SERVICE_ID, TEMPLATE_ID, formData, PUBLIC_KEY);
      setStatus("✅ Message sent successfully!");
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      console.error("EmailJS Error:", error);
      setStatus("❌ Failed to send message.");
    }
  };

  return (
    <div className="contactus-container">
      <h2 className="contactus-title">Contact Us</h2>

      <div className="contactus-wrapper">
        <div className="contactus-info">
          <h3>BinRashid Group Egypt</h3>
          <p>
            <strong>Address:</strong>
            <br />
            Lasirena building, Ring Rd, El Katameya, Level 1.
          </p>
          <p>
            <strong>Phone:</strong>
          </p>
          <ul>
            <li>🇪🇬 +20 12 1222 0604</li>
            <li>🇪🇬 +20 12 1222 0605</li>
          </ul>
          <p>
            <strong>Email:</strong> info@binrashideg.com
          </p>
        </div>

        <form className="contactus-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="subject"
            placeholder="Subject"
            value={formData.subject}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            required
          />
          <button type="submit">Send Message</button>
          {status && <p className="form-status">{status}</p>}
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
